export const NETWORK_RPC_URLS: { [key: number]: string } = {
  666666666: 'https://rpc.degen.tips',
  8453: 'https://mainnet.base.org',
};
